<div class="ability-dialog" ghs-pointer-input (singleClick)="close()" [ngClass]="{ closed: !opened, opened: opened }">
  @if (!!abilityCard) {
    <div
      class="ability-container"
      [ngClass]="{
        'bottom-actions': (abilityCard && abilityCard.bottomActions && abilityCard.bottomActions.length > 0) || false,
        'second-ability': !!secondAbilityCard
      }"
    >
      <ghs-ability-card
        [abilityCard]="abilityCard"
        [monster]="monster"
        [character]="character"
        [flipped]="opened"
        [relative]="relative"
        [interactiveAbilities]="interactiveAbilities"
        [activeActions]="!!monster && monster.firstActiveAction ? (monster.firstActiveAction === 'bottom' ? 'bottom' : 'top') : false"
      ></ghs-ability-card>
    </div>
  }
  @if (!!secondAbilityCard) {
    <div
      class="ability-container"
      [ngClass]="{
        'bottom-actions': (secondAbilityCard && secondAbilityCard.bottomActions && secondAbilityCard.bottomActions.length > 0) || false,
        'second-ability': !!secondAbilityCard
      }"
    >
      <ghs-ability-card
        [abilityCard]="secondAbilityCard"
        [monster]="monster"
        [character]="character"
        [flipped]="opened"
        [relative]="relative"
        [interactiveAbilities]="interactiveAbilities"
        [activeActions]="!!monster && monster.firstActiveAction ? (monster.firstActiveAction === 'bottom' ? 'top' : 'bottom') : false"
      ></ghs-ability-card>
    </div>
  }
</div>
<div class="close-container" (click)="close()"></div>
